import axios from 'axios';
import { authService } from './authService';
import { ENDPOINTS } from '../config/endpoints';

/**
 * Запросы экрана к bit-meetbot, которые не про конкретную встречу.
 *
 * Адрес — прокси-путь фронта (`/meetbot-api`, nginx.conf.template и
 * setupProxy.js): своего домена у бота нет.
 */
export const meetbotService = {
  /**
   * Площадки, на которые бот идёт сейчас (включает админка).
   *
   * Потолок ожидания короткий: разбор ссылки на видео ждёт этот ответ, и
   * зависший бот не должен вешать её.
   *
   * Returns:
   *   Массив `{name, title, short, hosts, match}` из `GET /platforms`.
   */
  async getPlatforms() {
    return (await this.getPlatformsState())?.platforms;
  },

  /**
   * Весь ответ `GET /platforms`: `{platforms, source}`.
   *
   * `source` — откуда бот взял набор: `settings` (настройка из админки
   * прочитана), `stale` (bit-auth не ответил, действует последнее
   * прочитанное), `env` (не прочитана ни разу — флаги окружения бота).
   */
  async getPlatformsState() {
    const response = await axios.get(`${ENDPOINTS.meetbot}/platforms`, {
      headers: authService.getAuthHeaders(),
      timeout: 5000,
    });
    return response?.data;
  },
};
